import React, { Fragment, Component } from 'react';
import DataGrid, {
    Column,
    Paging,
    SortByGroupSummaryInfo,
    Editing, Lookup,
    RequiredRule,
    PatternRule,
    StringLengthRule,
    Summary, TotalItem,
} from 'devextreme-react/data-grid'; //npm i devextreme-react
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import { getRequestParams, formatDate } from '../../helpers/globalfunctions.js';
import { alphanumericValidation, floatValidation, numberValidation,alphanumericSpecialcaseValidation } from '../../helpers/globalvalidations.js';
import DateBox from 'devextreme-react/date-box';
import { precisionFormats, currencySymbolFormats } from '../../helpers/fixcodes.js';
import { LoadPanel } from 'devextreme-react/load-panel';
import Modal from 'react-modal'; //npm install --save react-modal
import { SelectBox } from 'devextreme-react/select-box';
import NumberBox from 'devextreme-react/number-box';
import Swal from 'sweetalert2'; //npm i sweetalert2 --save
import { OrderStatus, documentType } from '../../helpers/fixcodes.js';
import axios from 'axios'; //npm install--save axios;
const position = { of: '#historydiv' };
const customStyles = {
    content: {
        width: '50%',
    }
}
export class PurchseOrderComponent extends Component {
    static displayName = PurchseOrderComponent.name;
    constructor(props) {
        super(props);
        this.grdPurchaseOrderAttributesRef = React.createRef();
        this.state = {
            isSubmited: false,
            loadPanelVisible: false,
            documentModelIsOpen: false,
            accountList: null,
            paymentTermList: null,
            itemList: [],
            itemDetails: [],
            hsnsacList: null,
            orderStatusList: null,
            id: 0,
            accountId: this.props.location.state === undefined ? 0 : this.props.location.state.customerId,
            orderNo: this.props.location.state === undefined ? "" : this.props.location.state.orderNo,
            orderDate: this.props.location.state === undefined ? new Date() : this.props.location.state.orderDate,
            shippingDate: this.props.location.state === undefined ? new Date() : this.props.location.state.shippingDate,
            invoiceNo: this.props.location.state === undefined ? "" : this.props.location.state.invoiceNo,
            paymentTermId: 0,
            shippingCharges: 0.00,
            discount: 0.00,
            otherCharges: 0.00,
            grossAmount: 0.00,
            remarks: "",
            termsAndConditions: "",
            accountTaxList: null,
            sessionUser: JSON.parse(sessionStorage.getItem("sessionUser")),
            purchaseOrderId: this.props.location.state === undefined ? 0 : this.props.location.state.purchaseorderId,
            isNewItem: false,
            orderStatusId: 0,
            imageList: [],
            pdfList: [],
            excelList: [],
            otherList: [],
            documentSelectedFile: [],
            purchaseDocumentOrderId: 0,
            resultMeassage: "",
            targetFile: [],
            hsnId: 0,
            taxshippingValue: 0,
            taxOtherCharges: 0,
            taxDiscount: 0,
            taxTotalAmount: 0,
            taxSubTotal: 0,
            showTaxAmount: 0,
            errors: {
                accountId: 0,
                orderNo: "",
                orderDate: new Date(),
                shippingDate: new Date(),
                paymentTermId: 0,
                shippingCharges: 0.00,
                discount: 0.00,
                otherCharges: 0.00,
                grossAmount: 0.00,
                remarks: "",
                termsAndConditions: "",
                itemDetailsGrid: "",
            }
        }

        this.assginData = this.assginData.bind(this);
        this.handlePurchaseOrderSubmit = this.handlePurchaseOrderSubmit.bind(this);
    }

    async componentDidMount() {
        this.setState({
            loadPanelVisible: true
        });
        await this.getAccounts();
        await this.getPaymentTerms();
        await this.getItemMaster();
        await this.getHsnCodeMaster();

        if (this.state.purchaseOrderId > 0) {
            await this.getPurchaseOrderMaster();
        }
        this.setState({
            loadPanelVisible: false
        });
    }


    getPurchaseOrderMaster = async () => {
        this.setState({
            loadPanelVisible: true
        });
        try {
            var request = {};
            request.DeliveryDate = this.state.shippingDate === "" ? "" : formatDate(this.state.shippingDate, "yyyy-MM-dd");
            request.PODate = this.state.orderDate === "" ? "" : formatDate(this.state.orderDate, "yyyy-MM-dd");
            request.CustomerId = parseInt(this.state.accountId);
            request.InvoiceNo = this.state.invoiceNo;
            request.OrderNo = this.state.orderNo;
            request.purchaseOrderId = parseInt(this.state.purchaseOrderId);
            const requestParams = getRequestParams("POST", request);
            const response = await fetch(process.env.REACT_APP_API_BASE_URL + 'purchase/purchaseOrderDetails', requestParams);
            const data = await response.json();
            this.setState({
                salesordersource: data.payload,
                loadPanelVisible: false
            });

            this.assginData(data.payload);
        } catch (err) {
            console.log("Error in " + this.displayName + ".getPurchaseOrderMaster function", err);
            this.setState({
                loadPanelVisible: false
            });

            if (this.state.purchaseOrderId > 0) {
                // let myVar = setTimeout(() => this.assginData(), 500)
            }
        }
    }

    assginData = (salesOrder) => {
        if (salesOrder !== null && salesOrder !== undefined) {
            var orderSummary = salesOrder.orderSummary;
            var orderDetails = salesOrder.orderDetails;
            this.getOrderStatus();
            // this.getAccountTax(orderSummary.customerId);
            this.setState({
                id: orderSummary.id,
                accountId: orderSummary.customerId,
                orderNo: orderSummary.poNo,
                taxSubTotal : orderSummary.taxAmount,
                orderDate: formatDate(orderSummary.orderDate, "MM/dd/yyyy hh:mm"),
                shippingDate: formatDate(orderSummary.shippingDate, "MM/dd/yyyy hh:mm"),
                paymentTermId: orderSummary.paymentTermsId,
                shippingCharges: parseFloat(orderSummary.shippingCharges).toFixed(precisionFormats[2]),
                discount: parseFloat(orderSummary.discount).toFixed(precisionFormats[2]),
                otherCharges: parseFloat(orderSummary.otherCharges).toFixed(precisionFormats[2]),
                grossAmount: parseFloat(orderSummary.grossAmount).toFixed(precisionFormats[2]),
                remarks: orderSummary.remarks,
                termsAndConditions: orderSummary.termsCondition,
                itemDetails: orderDetails,
                orderStatusId: orderSummary.orderStatusId,
            });
        }
    }

    getOrderStatus = async () => {
        try {
            var request = {};
            const requestParams = getRequestParams("GET", request);
            var orderStatusId = parseInt(0);
            const response = await fetch(process.env.REACT_APP_API_BASE_URL + 'master/orderStatus/' + orderStatusId, requestParams);
            const data = await response.json();
            this.setState({
                orderStatusList: data.payload
            });
        } catch (err) {
            console.log("Error in " + this.displayName + ".getOrderStatus function", err);
        }
    }

    getAccounts = async () => {
        try {
            var request = {};
            const requestParams = getRequestParams("GET", request);
            const response = await fetch(process.env.REACT_APP_API_BASE_URL + 'account/dropdownAccount/3', requestParams);
            const data = await response.json();
            this.setState({
                accountList: data.payload
            });
        } catch (err) {
            console.log("Error in " + this.displayName + ".getAccounts function", err);
        }
    }


    getPaymentTerms = async () => {
        try {
            var request = {};
            const requestParams = getRequestParams("GET", request);
            const response = await fetch(process.env.REACT_APP_API_BASE_URL + 'paymentTermType/dropdownType', requestParams);
            const data = await response.json();
            this.setState({
                paymentTermList: data.payload
            });
        } catch (err) {
            console.log("Error in " + this.displayName + ".getPaymentTerms function", err);
        }
    }

    getItemMaster = async () => {
        try {
            var request = {};
            request.CategoryId = 0;
            request.HSNId = 0;
            request.ItemId = 0;
            const requestParams = getRequestParams("POST", request);
            const response = await fetch(process.env.REACT_APP_API_BASE_URL + 'items/item/', requestParams);
            const data = await response.json();
            this.setState({
                itemList: data.payload != null ? data.payload : []
            });
        } catch (err) {
            console.log("Error in " + this.displayName + ".getItemMaster function", err);
        }
    }

    getHsnCodeMaster = async () => {
        try {
            var request = {};
            const requestParams = getRequestParams("GET", request);
            const response = await fetch(process.env.REACT_APP_API_BASE_URL + 'hsnsacCode/hscacccodes/0', requestParams);
            const data = await response.json();
            this.setState({
                hsnsacList: data.payload,
            });
        } catch (err) {
            console.log("Error in " + this.displayName + ".getHsnCodeMaster function", err);
        }
    }

    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let errors = this.state.errors;

        switch (name) {
            // case 'OrderNo':
            //     if (alphanumericValidation.test(event.target.value))
            //         this.setState({ orderNo: event.target.value });
            //     break;
            case 'Remarks':
                if (alphanumericSpecialcaseValidation.test(event.target.value))
                    this.setState({ remarks: event.target.value });
                break;
            case 'TermsAndConditions':
                if (alphanumericValidation.test(event.target.value))
                    this.setState({ termsAndConditions: event.target.value });
                break;
            default:
                this.setState({ [name]: value });
                break;
        }
        errors[name] = "";
        //this.state.errors[name] = "";
        // this.setState({
        //     errors:{
        //         [name]: ""
        //     }
        // });
        this.setState({
            errors: errors
        });
    }

    handleCalculationInputChange = (event) => {
        
        const target = event.target;
        // const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        switch (name) {
            // case 'OrderNo':
            //     if (alphanumericValidation.test(event.target.value))
            //         this.setState({ orderNo: event.target.value });
            //     break;
            case 'shippingCharges':

                break;
            case 'otherCharges':

                break;
            default:
                //  this.setState({ [name]: value });
                break;
        }

    }

    getAccountTax = async (id) => {
        try {
            this.setState({ hsnId: id });
            var request = {};
            const requestParams = getRequestParams("GET", request);
            const response = await fetch(process.env.REACT_APP_API_BASE_URL + 'hsntax/HSNCodeTax/' + id, requestParams);
            const data = await response.json();
            
            this.setState({
                accountTaxList: data.payload != null ? data.payload : [],
            });
            if (data.payload == null) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: "Please set tax for the item",
                }).then((result) => {
                    if (result.isConfirmed) {
                        if (data.isSuccess) {
                            this.setState({ itemDetails: null })
                        }
                    }
                    this.setState({ isSubmited: false })
                });
            }

        } catch (err) {
            console.log("Error in " + this.displayName + ".getContractList function", err);
        }
    }

    onRowInserting = async (e) => {
        //  
        this.setState({ isNewItem: true });
    }

    handleShippingChargesChange = (event) => {
       // const newValue = event.value;
        // this.setState({ "shippingCharges": newValue });
        const newValue = event.value == null ? 0 : event.value;
        var totalTax = 0.00;
        // var singleTax = newValue === 0 ? 0: ((newValue * 18) / 100);
        if (newValue > 0) {
            if (this.state.accountTaxList !== null) {
                if (this.state.accountTaxList.length > 0) {
                    this.state.accountTaxList.map((taxitem, i) => {
                        var singleTax = parseFloat(((newValue * taxitem.percentage) / 100), 2);
                        totalTax = totalTax + singleTax;
                    });
                }
            }
        }

        this.setState({ "shippingCharges": newValue, taxshippingValue: totalTax });
        // var charge = parseFloat(this.state.otherCharges) + parseFloat(totalTax) + parseFloat(this.state.taxTotalAmount) + parseFloat(newValue)
        var charge = parseFloat(this.state.otherCharges) + parseFloat(totalTax) + parseFloat(this.state.showTaxAmount) + parseFloat(newValue)
        
        var newgrossAmount = parseFloat(charge) - parseFloat(this.state.discount);
        //var newgrossAmount = parseFloat(this.state.discount) + parseFloat(this.state.otherCharges) + parseFloat(newValue)
        this.setState({ grossAmount: newgrossAmount, taxshippingValue: totalTax });

    }

    handleDiscountChange = (event) => {
        const newValue = event.value == null ? 0 : event.value;
        this.setState({ "discount": newValue });
        //  var test = parseFloat(this.state.taxOtherCharges) + parseFloat(this.state.taxshippingValue)+parseFloat(this.state.taxTotalAmount)+ parseFloat(this.state.shippingCharges) + parseFloat(this.state.otherCharges)
        var test = parseFloat(this.state.taxOtherCharges) + parseFloat(this.state.taxshippingValue) + parseFloat(this.state.showTaxAmount) + parseFloat(this.state.shippingCharges) + parseFloat(this.state.otherCharges)
        var newgrossAmount = parseFloat(test) - parseFloat(newValue)
        this.setState({ grossAmount: newgrossAmount });
    }

    handleOtherChargesChange = (event) => {
        const newValue = event.value == null ? 0 : event.value;
        // var singleTax = newValue === 0 ? 0: ((newValue * 18) / 100);
        var totalTax = 0.00;
        if (newValue > 0) {
            if (this.state.accountTaxList !== null) {
                if (this.state.accountTaxList.length > 0) {
                    this.state.accountTaxList.map((taxitem, i) => {
                        var singleTax = parseFloat(((newValue * taxitem.percentage) / 100), 2);
                        totalTax = totalTax + singleTax;
                    });
                }
            }

        }
        this.setState({ "otherCharges": newValue, taxOtherCharges: totalTax });
        // var charge =   parseFloat(totalTax) + parseFloat(this.state.taxshippingValue) + parseFloat(this.state.taxTotalAmount) + parseFloat(newValue)
        var charge = parseFloat(totalTax) + parseFloat(this.state.taxshippingValue) + parseFloat(this.state.showTaxAmount) + parseFloat(newValue)
        var newgrossAmount = parseFloat(charge) - parseFloat(this.state.discount);
        this.setState({ grossAmount: newgrossAmount });
    }

    handleGrossAmountChange = (event) => {
        const newValue = event.value;
        this.setState({ "grossAmount": newValue });
    }

    handleAccountChange = (selectedOption) => {
        this.setState({
            accountId: (selectedOption.selectedItem !== null ? selectedOption.selectedItem.id : 0),
        });
        let errors = this.state.errors;
        if (selectedOption.selectedItem !== null && selectedOption.selectedItem.id > 0) {
            //this.state.errors["accountId"] = "";
            errors.accountId = "";
            this.setState({
                errors: errors
            });
        }

    }

    handlePaymentTermChange = (selectedOption) => {
        this.setState({
            paymentTermId: (selectedOption.selectedItem !== null ? selectedOption.selectedItem.id : 0),
        });
        let errors = this.state.errors;
        if (selectedOption.selectedItem !== null && selectedOption.selectedItem.id > 0) {
            //this.state.errors["paymentTermId"] = "";
            errors.paymentTermId = "";
            this.setState({
                errors: errors
            });
        }
    }

    handleOrderStatusChange = (selectedOption) => {
        this.setState({
            orderStatusId: (selectedOption.selectedItem !== null ? selectedOption.selectedItem.id : 0),
        });
    }

    handleOrderDateChanged = (date) => {
        this.setState({
            orderDate: date.value,
            shippingDate: date.value
        });
    }

    handleShippingDateChanged = (date) => {
        this.setState({ shippingDate: date.value });
    }

    calculateQtyChange = (newData, value, currentRowData) => {
        if (this.state.accountTaxList.length == 0) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: "Please set tax for the item",
            }).then((result) => {
                if (result.isConfirmed) {

                    return;

                }

            });
        }
        else {
            newData.qty = parseInt(value);
            var totalItemPrice = 0.00;
            totalItemPrice = currentRowData.price !== undefined ? parseFloat(currentRowData.price, 3) * value : 0;
            var totalTax = 0.00;
            newData.totalAmount = (parseFloat(totalItemPrice, 3)).toFixed(precisionFormats[2]);
        if (newData.totalAmount > 0) {
            if (this.state.accountTaxList.length > 0) {
                this.state.accountTaxList.map((taxitem, i) => {
                    var singleTax = parseFloat(((newData.totalAmount * taxitem.percentage) / 100), 2);
                    totalTax = totalTax + singleTax;
                });
            }
        
            var taxSubTotalAmount = parseFloat(totalTax).toFixed(precisionFormats[2]);
            var newGrossAmount = parseFloat(totalTax) + parseFloat(newData.totalAmount)
            this.setState({ showTaxAmount: newGrossAmount, grossAmount: newGrossAmount, taxSubTotal: taxSubTotalAmount });
            // if (totalItemPrice > 0) {
            //     if (this.state.accountTaxList.length > 0) {
            //         this.state.accountTaxList.map((taxitem, i) => {
            //             var singleTax = parseFloat(((totalItemPrice * taxitem.percentage) / 100), 2);
            //             totalTax = totalTax + singleTax;
            //         });
            //     }
            // }
            // newData.taxAmount = parseFloat(totalTax, 2).toFixed(precisionFormats[2]);
            // newData.totalAmount = (parseFloat(totalTax, 2) + parseFloat(totalItemPrice, 3)).toFixed(precisionFormats[2]);
            // this.setState ({ grossAmount : newData.totalAmount});
        }
            return newData;
        }

    }

    calculatePriceChange = (newData, value, currentRowData) => {
        newData.price = parseFloat(value).toFixed(precisionFormats[2]);
        var totalItemPrice = 0.00;
        totalItemPrice = currentRowData.qty !== undefined ? parseFloat(currentRowData.qty, 3) * value : 0;
        var totalTax = 0.00;
        // if (totalItemPrice > 0) {
        //     if (this.state.accountTaxList.length > 0) {
        //         this.state.accountTaxList.map((taxitem, i) => {
        //             var singleTax = parseFloat(((totalItemPrice * taxitem.percentage) / 100), 2);
        //             totalTax = totalTax + singleTax;
        //         });
        //     }
        // }
        // newData.taxAmount = parseFloat(totalTax, 2).toFixed(precisionFormats[2]);
        // newData.totalAmount = (parseFloat(totalTax, 2) + parseFloat(totalItemPrice, 3)).toFixed(precisionFormats[2]);
        // // this.setState ({ grossAmount : newData.totalAmount + newData.totalAmount});
   
        newData.totalAmount = (parseFloat(totalItemPrice, 3)).toFixed(precisionFormats[2]);
        if (newData.totalAmount > 0) {
            if (this.state.accountTaxList.length > 0) {
                this.state.accountTaxList.map((taxitem, i) => {
                    
                    var singleTax = parseFloat(((newData.totalAmount * taxitem.percentage) / 100), 2);
                    totalTax = totalTax + singleTax;
                });
            }
            var taxSubTotalAmount = parseFloat(totalTax).toFixed(precisionFormats[2]);
            var newGrossAmount = parseFloat(totalTax) + parseFloat(newData.totalAmount)
            this.setState({ showTaxAmount: newGrossAmount, grossAmount: newGrossAmount, taxSubTotal: taxSubTotalAmount });
        }
     }

    calculateDiscountChange = (newData, value, currentRowData) => {
        newData.discount = parseFloat(value).toFixed(precisionFormats[2]);
        newData.totalAmount = (parseFloat(currentRowData.totalAmount) - parseFloat(value)).toFixed(precisionFormats[2]);
        //this.setState ({ grossAmount : newData.totalAmount});
    }
    totalGrossAmount = (newData, value, currentRowData) => {

    }


    handleValidation = () => {
        let formIsValid = true;
        try {
            let errors = this.state.errors;
            errors.accountId = 0;
            //errors.orderNo = "";
            // errors.paymentTermId = 0;
            // errors.shippingCharges = "";
            // errors.discount = "";
            // errors.otherCharges = "";
            //errors.grossAmount = "";
            errors.itemDetailsGrid = ""
            errors.remarks = "";

            if (this.state.accountId === 0) {
                formIsValid = false;
                errors.accountId = "Please select vendor.";
            }
            // if (this.state.orderNo.trim() === "") {
            //     formIsValid = false;
            //     errors.orderNo = "Please enter order number.";
            // }
            // if (this.state.paymentTermId === 0) {
            //     formIsValid = false;
            //     errors.paymentTermId = "Please select payment term.";
            // }
            // if (this.state.shippingCharges === 0) {
            //     formIsValid = false;
            //     errors.shippingCharges = "Please enter shipping charges.";
            // }
            // if (this.state.discount === 0) {
            //     formIsValid = false;
            //     errors.discount = "Please enter discount.";
            // }
            // if (this.state.otherCharges === 0) {
            //     formIsValid = false;
            //     errors.otherCharges = "Please enter other charges.";
            // }
            // if(this.state.grossAmount === 0){
            //     formIsValid = false;
            //     errors.grossAmount = "Please enter gross acmount.";
            // }
            if (this.state.itemDetails.length == 0) {
                formIsValid = false;
                errors.itemDetailsGrid = "Please enter item(s).";
            }
            if (this.state.remarks.trim() === "") {
                formIsValid = false;
                errors.remarks = "Please enter remarks.";
            }
            this.setState({ errors: errors });
        }
        catch (err) {
            console.log("Error in " + this.displayName + ".handleValidation function", err);
            this.setState({ isSubmited: false })
        }
        return formIsValid;
    }

    handlePurchaseOrderSubmit = async (e) => {
        e.preventDefault();
        try {
            if (this.handleValidation()) {
                this.setState({
                    isSubmited: true
                })
                
                const dataSource = this.refs.grdPurchaseOrderAttributesRef.instance.getDataSource();
                var attributeArray = dataSource._items;

                var request = {};
                request.PONo = this.state.orderNo;
                request.PODate = formatDate(this.state.orderDate, "MM/dd/yyyy hh:mm");
                request.VendorId = 0;
                request.CustomerId = this.state.accountId;
                request.PaymentTermsId = this.state.paymentTermId;
                request.OrderStatusId = this.state.purchaseOrderId === 0 ? parseInt(OrderStatus.PENDING) : this.state.orderStatusId;
                request.HSNId = this.state.hsnId;
                request.ShippingCharges = parseFloat(this.state.shippingCharges);
                request.OtherCharges = parseFloat(this.state.otherCharges);

                var orderItemsList = [];
                var totalAmount = 0, taxAmount = 0;

                attributeArray.forEach((element, index) => {
                    
                    var orderItemRequest = {};
                    orderItemRequest.Id = this.state.isNewItem === true ? 0 : element.id;
                    orderItemRequest.ItemId = element.itemId;
                    orderItemRequest.ItemName = "";
                    orderItemRequest.Description = element.description;
                    orderItemRequest.HSNSACCode = element.hsnsacCode;
                    orderItemRequest.Qty = parseInt(element.qty);
                    orderItemRequest.Price = parseFloat(element.price);
                    orderItemRequest.Discount = element.discount == undefined ? 0.0 : parseFloat(element.discount);
                    orderItemRequest.TotalAmount = parseFloat(element.totalAmount);
                    orderItemRequest.TaxAmount = parseFloat(0);
                    orderItemRequest.Remarks = "";
                    orderItemRequest.WarrentyTerms = "";
                    totalAmount = totalAmount + parseFloat(element.totalAmount);
                    taxAmount = taxAmount + parseFloat(element.taxAmount);
                    orderItemsList.push(orderItemRequest);


                });
                request.OrderDetails = {};
                request.OrderDetails = orderItemsList;
                request.TotalAmount = parseFloat(totalAmount);
                request.Discount = parseFloat(this.state.discount);
                request.TaxAmount = parseFloat(this.state.taxSubTotal);;
                request.GrossAmount = parseFloat(this.state.grossAmount); //parseFloat(totalAmount) - parseFloat(this.state.discount) + parseFloat(this.state.otherCharges) + parseFloat(this.state.shippingCharges);
                request.Remarks = this.state.remarks;
                request.TermsCondition = this.state.termsAndConditions;
                request.POOrderDocument = "";
                request.UserId = this.state.sessionUser.id;
                request.ApprovedBy = this.state.sessionUser.id;
                request.DeliveryDate = formatDate(this.state.shippingDate, "MM/dd/yyyy hh:mm");
                request.Source = "Web";
                request.CreatedBy = this.state.sessionUser.id;
                request.CreatedOn = formatDate(new Date(), "MM/dd/yyyy hh:mm");
                request.UpdatedBy = this.state.sessionUser.id;
                request.UpdatedOn = formatDate(new Date(), "MM/dd/yyyy hh:mm");

                const requestParams = getRequestParams('POST', request);
                const response = await fetch(process.env.REACT_APP_API_BASE_URL + 'purchase/' + this.state.id + '/purchaseOrder', requestParams);
                const data = await response.json();
                if (data.isSuccess) {
                    this.setState({ purchaseDocumentOrderId: data.payload, resultMeassage: data.message })
                    if (this.state.documentSelectedFile.size !== undefined || this.state.documentSelectedFile.length > 0) {
                        if (this.state.id === 0) {
                            setTimeout(() => this.documentUpload(), 100);
                        }
                    }
                    else {
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: data.message,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                // this.documentUpload();
                                window.location.href = "/purchaseorder/list";
                            }
                            this.setState({ isSubmited: false })
                        })
                    }


                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: data.message,
                    }).then((result) => {
                        if (result.isConfirmed) {
                        }
                        this.setState({ isSubmited: false })
                    })

                    // toast.error(data.message, {
                    //     position: toast.POSITION.TOP_CENTER,
                    //     autoClose: 2000,
                    //     style: { width: "310px" },
                    //     hideProgressBar: false,
                    //     newestOnTop: false,
                    //     closeButton: false
                    // });
                    this.setState({ isSubmited: false })
                }

                this.setState({
                    isSubmited: false
                })
            }
        } catch (err) {
            console.log("Error in " + this.displayName + ".handlePurchaseOrderSubmit function", err);
            this.setState({ isSubmited: false })
        }
    }

    handleClearControls = () => {
        this.setState({
            isSubmited: false,
            loadPanelVisible: false,
            accountList: [],
            paymentTermList: [],
            itemList: [],
            itemDetails: [],
            hsnsacList: [],
            orderStatusList: [],
            id: 0,
            accountId: 0,
            orderNo: "",
            orderDate: new Date(),
            shippingDate: new Date(),
            paymentTermId: 0,
            shippingCharges: 0.00,
            discount: 0.00,
            otherCharges: 0.00,
            grossAmount: 0.00,
            remarks: "",
            termsAndConditions: "",
            accountTaxList: [],
            sessionUser: JSON.parse(sessionStorage.getItem("sessionUser")),
            purchaseOrderId: this.props.location.state === undefined ? "" : this.props.location.state.purchaseOrderId,
            isNewItem: false,
            orderStatusId: 0,
            errors: {
                accountId: 0,
                orderNo: "",
                orderDate: new Date(),
                shippingDate: new Date(),
                paymentTermId: 0,
                shippingCharges: 0.00,
                discount: 0.00,
                otherCharges: 0.00,
                grossAmount: 0.00,
                remarks: "",
                termsAndConditions: "",
            }
        });
    }
    handleCancel = () => {
        window.location.href = "/purchaseorder/list";
    }
    openDocumentModel = () => {
        this.setState({
            documentModelIsOpen: true
        });
        this.getDocuments();
    }
    closeDocumentModel = () => {
        this.setState({
            documentModelIsOpen: false
        });
    }
    getDocuments = async () => {
        try {
            this.setState({
                loadPanelVisible: true
            });
            const requestParams = getRequestParams('GET', {});
            const response = await fetch(process.env.REACT_APP_API_BASE_URL + 'file/' + parseInt(documentType.PurchaseOrder) + '/' + this.state.purchaseOrderId + '/documents', requestParams);
            const data = await response.json();
            var imageListObj = [];
            var pdfListObj = [];
            var excelListObj = [];
            var otherListObj = [];
            if (data.documents != null && data.documents.length > 0) {
                for (var i = 0; i < data.documents.length; i++) {
                    if (data.documents[i].fileGuid != '00000000-0000-0000-0000-000000000000') {
                        var img = {};
                        const requestParamsImage = getRequestParams('GET', '');
                        const responseImage = await fetch(process.env.REACT_APP_API_BASE_URL + 'file/download/' + data.documents[i].fileGuid, requestParamsImage);
                        const dataImage = await responseImage.json();
                        if (dataImage.fileExtension.toUpperCase() === '.PDF') {
                            img.src = 'data:' + dataImage.mimeType + ';base64,' + dataImage.fileContent;
                            img.fileGuid = data.documents[i].fileGuid;
                            img.fileName = dataImage.fileName;
                            pdfListObj.push(img);
                        } else if (dataImage.fileExtension.toUpperCase() === '.XLXS' || dataImage.fileExtension.toUpperCase() === '.CSV' || dataImage.fileExtension.toUpperCase() === '.XLS') {
                            img.src = 'data:' + dataImage.mimeType + ';base64,' + dataImage.fileContent;
                            img.fileGuid = data.documents[i].fileGuid;
                            img.fileName = dataImage.fileName;
                            excelListObj.push(img);
                        } else if (dataImage.fileExtension.toUpperCase() === '.JPG' || dataImage.fileExtension.toUpperCase() === '.PNG' || dataImage.fileExtension.toUpperCase() === '.JPEG') {
                            img.src = 'data:' + dataImage.mimeType + ';base64,' + dataImage.fileContent;
                            img.fileGuid = data.documents[i].fileGuid;
                            imageListObj.push(img);
                        } else {
                            img.src = 'data:' + dataImage.mimeType + ';base64,' + dataImage.fileContent;
                            img.fileGuid = data.documents[i].fileGuid;
                            img.fileName = dataImage.fileName;
                            otherListObj.push(img);
                        }
                    }
                }
            }

            this.setState({
                loadPanelVisible: false,
                imageList: imageListObj,
                pdfList: pdfListObj,
                excelList: excelListObj,
                otherList: otherListObj
            });

        } catch (e) {
            console.log(e);
        }
    }
    onEditorPreparing = (e) => {
        if (e.parentType === "dataRow" && e.dataField === "itemId") {

            e.editorOptions.onValueChanged = (ev) => {
                let selectedItem = ev.component.option("selectedItem");
                e.setValue(selectedItem);
            };
        }
    }
    setCellValue = (rowData, value) => {
        rowData.itemId = value.id;
        rowData.hsnsacCode = value.hsnCode;
        rowData.price = value.unitPrice;
        this.getAccountTax(value.hsnId);
    }


    handleFileInputChange = async (e) => {
        let images = e.target.files;
        var i;
        for (i = 0; i < e.target.files.length; i++) {
            this.state.targetFile.push(images[i]);
        }
        this.setState({
            documentSelectedFile: this.state.targetFile
        })
        // console.log(this.state.documentSelectedFile);
    }
    resetFileInput = (e) => {
        var data = this.state.documentSelectedFile.filter(item => item.name === e.target.value);
        var _data = this.state.documentSelectedFile.filter(item => item.name !== data[0].name);
        //var data1 = this.state.documentSelectedFile.filter(item => item.name === data[0].name);
        this.setState({
            documentSelectedFile: _data,
            targetFile: _data
        }, () => 500)
        const arrLength = _data.length;
        console.log(arrLength - 1);
        if (_data.length == 0) {
            this.removeAll();
        }
        else {
            document.getElementById("file").value = null
        }
    };
    removeAll = () => {
        document.getElementById("file").value = null;
    }
    documentUpload = async () => {
        for (let i = 0; i < this.state.documentSelectedFile.length; i++) {
            //if (this.state.documentSelectedFile.size > 0) 
            {
                const url = process.env.REACT_APP_API_BASE_URL + 'file/upload';
                const formData = new FormData();
                console.log(this.state.documentSelectedFile);
                formData.append('body', this.state.documentSelectedFile[i]);
                const config = {
                    headers: {
                        'content-type': 'multipart/form-data',
                        'UserId': this.state.sessionUser.id,
                        'Authorization': 'Bearer ' + sessionStorage.getItem('session_token'),
                    },
                };
                this.setState({
                    loadPanelVisible: true
                });
                axios.post(url, formData, config).then((response) => {
                    var resp = response.data;
                    if (resp != null) {
                        this.setState({
                            fileGuid: resp.fileGuid
                        })
                        this.saveDocument(resp)
                    }
                });
                this.setState({
                    loadPanelVisible: false
                });
            }
        }
    }
    saveDocument = async (data) => {
        this.setState({
            isSubmited: true
        })
        if (data !== null) {
            this.setState({
                fileGuid: data.fileGuid
            });
            try {
                var isSuccess = false;
                var resultMessage = '';
                //for (var i = 0; i < this.state.uniqueId.length; i++)
                {
                    var request = new Object();
                    request.FileGuid = data.fileGuid;
                    request.FileRecordType = parseInt(4);
                    request.UserId = Number(this.state.sessionUser.id);
                    request.DocumentType = parseInt(documentType.PurchaseOrder);
                    request.Id = this.state.purchaseDocumentOrderId;
                    const requestDocumentParams = getRequestParams('POST', request);
                    const responseDocument = await fetch(process.env.REACT_APP_API_BASE_URL + 'file/save-documents', requestDocumentParams);
                    const dataDocument = await responseDocument.json();
                    isSuccess = dataDocument.isSuccess;
                    resultMessage = dataDocument.message;
                }
                this.setState({
                    isSubmited: false
                })
                if (isSuccess) {
                    Swal.fire({
                        icon: isSuccess ? 'success' : 'error',
                        title: isSuccess ? 'success' : 'Oops...',
                        text: this.state.resultMeassage,
                    }).then((result) => {
                        if (isSuccess) {
                            window.location.href = "/purchaseorder/list"
                            //  this.closeModel();
                            //this.getDocuments();
                        }
                    });
                } else {
                    this.onfailure('Failed to upload image.', resultMessage);
                }
            } catch (e) {
                //
            }

        }
    }
    //     onSaving = (event)=>{
    // 
    //     }
    //     onSaved = (event) =>{
    //         var grossAmount = 0;
    //         event.changes.map((amount,i)=>{
    //            // total= total + amount.data.totalAmount
    //             grossAmount = parseInt(amount.data.totalAmount) + parseInt(this.state.grossAmount);
    //             
    //             this.setState({grossAmount : this.state.grossAmount});
    //             console.log(this.state.grossAmount)
    //         });



    //     }

    calculateSelectedRow = (options) => {
        if (options.name === 'SelectedRowsSummary') {
            if (options.summaryProcess === 'start') {
                options.totalValue = 0.00;
            } else if (options.summaryProcess === 'calculate') {
                options.totalValue += parseInt(options.value.discount);
                var amount = options.totalValue
                // this.setState({ discount: amount });
            }
        }
        else
            if (options.name === 'SelectedTotalSummary') {
                if (options.summaryProcess === 'start') {
                    options.totalValue = 0.00;
                } else if (options.summaryProcess === 'calculate') {
                    options.totalValue += parseInt(options.value.totalAmount);
                    var amount = options.totalValue
                    var newGrossAmount = amount

                    if (this.state.purchaseOrderId == 0) {
                        this.setState({ grossAmount: this.state.grossAmount });
                    }
                    else if(this.state.purchaseOrderId !== 0 ){
                        this.setState({ grossAmount: this.state.grossAmount });
                    }
                    else if(this.state.showTaxAmount == 0){
                        this.setState({ grossAmount: amount ,showTaxAmount : newGrossAmount});
                    }
                    else{
                        var updateshowTax = parseFloat(this.state.taxSubTotal) + parseFloat(newGrossAmount)
                        this.setState({ grossAmount: updateshowTax ,showTaxAmount : updateshowTax});
                    }

                }
            }
    }
    // onSaved = (e) =>{
    //     
    //     console.log(this.state.accountTaxList);
    //     if(this.state.accountTaxList.length === 0){
    //         console.log(this.state.itemDetails);
    //         var gridData = this.state.itemDetails
    //         gridData.forEach((e,index)=>{
    // if(e.taxAmount == '0.00'){
    //     
    // e.itemId = 0;e.hsnsacCode = ''
    // }
    //         });
    //     }
    //

    render() {
        const customizeQtyText = (data) => {
            return `Total - ${data.value.toFixed(precisionFormats[0])}`;
        }

        const customizePriceText = (data) => {
            return `Total - ${data.value.toFixed(precisionFormats[2])}`;
        }

        const customizeTaxText = (data) => {
            return `Total - ${data.value.toFixed(precisionFormats[2])}`;
        }

        const customizeDiscountText = (data) => {
            return `Total - ${data.value.toFixed(precisionFormats[2])}`;
        }

        const customizeTotalAmountText = (data) => {
            // this.setState({grossAmount : data.value })
            return `Total - ${data.value.toFixed(precisionFormats[2])}`;

        }

        const renderGridNumberCell = (data) => {
            return <div><small><i class={currencySymbolFormats.currencyFormat}></i></small>&nbsp;&nbsp;{parseFloat(data.value !== undefined ? data.value : 0.00).toFixed(precisionFormats[2])}</div>;

        }
        return (
            <Fragment>
                <div className="section-body">
                    <div className='card bg-filter'>
                        <div className='card-body'>
                            <div className="section-header">
                                <h6 className='m-0'>{this.state.purchaseOrderId > 0 ? "Update Purchase Order" : "New Purchase Order"} </h6>
                                <div className="section-header-buttons">
                                    <button type="submit" className="btn btn-success" onClick={this.handlePurchaseOrderSubmit} >
                                        {this.state.isSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                        {!this.state.isSubmited && <span title="Submit">Submit</span>}
                                    </button>&nbsp;&nbsp;
                                    {/* <button type="submit" className="btn btn-success">
                                    <span title="Save and Print"><i className="fas fa-print"></i> Save and Print</span>
                                </button>&nbsp;&nbsp; */}
                                    <button type="submit" className="btn btn-outline-secondary" onClick={this.handleCancel}>
                                        <span title="Cancel">Cancel</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='card mb-2'>
                        <div className='card-body'>
                            <div className='sub-title-color font-weight-bold'>Order Info</div>
                            <div className='row'>
                                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                    <div className="form-group">
                                        <label htmlFor="">Vendor <span className="text-danger">*</span></label>
                                        <SelectBox
                                            dataSource={this.state.accountList}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select vendor"
                                            name="id"
                                            defaultValue={0}
                                            value={this.state.accountId}
                                            displayExpr='name'
                                            valueExpr='id'
                                            onSelectionChanged={this.handleAccountChange}
                                            showClearButton={true}
                                            disabled={this.state.id > 0}
                                            searchEnabled={true}
                                        />
                                        {this.state.errors["accountId"].length > 0 && <span className="error invalid-feedback">{this.state.errors["accountId"]}</span>}
                                    </div>
                                </div>
                                {
                                    this.state.id > 0 ?
                                        <div className="col-lg-2 col-md-3 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <label htmlFor="">Order#</label>
                                                <input type="text" className="form-control form-control-sm" name="orderNo" placeholder="Enter order#" value={this.state.orderNo}
                                                    disabled={this.state.id > 0} title="Order No" maxLength="20" onChange={this.handleInputChange} />
                                                {this.state.errors["orderNo"].length > 0 && <span className="error invalid-feedback">{this.state.errors["orderNo"]}</span>}
                                            </div>
                                        </div> : null}
                                <div className="col-lg-2 col-md-3 col-sm-12 col-xs-12">
                                    <div className="form-group">
                                        <label htmlFor="">Order Date</label>
                                        <DateBox type="date"
                                            className="replay-date-time"
                                            name="orderDate"
                                            placeholder="dd/mm/yyyy"
                                            displayFormat="dd/MM/yyyy"
                                            showAnalogClock={true}
                                            useMaskBehavior={true}
                                            defaultValue={this.state.orderDate}
                                            value={this.state.orderDate}
                                            onValueChanged={this.handleOrderDateChanged}
                                            width="100%"
                                            disabled={this.state.id > 0}
                                            acceptCustomValue={false}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-12 col-xs-12">
                                    <div className="form-group">
                                        <label htmlFor="">Shipping Date</label>
                                        <DateBox type="date"
                                            className="replay-date-time"
                                            name="shippingDate"
                                            placeholder="dd/mm/yyyy"
                                            displayFormat="dd/MM/yyyy"
                                            showAnalogClock={true}
                                            useMaskBehavior={true}
                                            defaultValue={this.state.shippingDate}
                                            value={this.state.shippingDate}
                                            onValueChanged={this.handleShippingDateChanged}
                                            min={this.state.shippingDate}
                                            width="100%"
                                            disabled={false}
                                            acceptCustomValue={false}
                                        />
                                    </div>
                                </div>
                                {/* <div className="col-lg-2 col-md-3 col-sm-12 col-xs-12">
                                    <div className="form-group">
                                        <label htmlFor="">Payment Term</label>
                                        <SelectBox
                                            dataSource={this.state.paymentTermList}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select payment term"
                                            name="id"
                                            defaultValue={0}
                                            value={this.state.paymentTermId}
                                            displayExpr='name'
                                            valueExpr='id'
                                            onSelectionChanged={this.handlePaymentTermChange}
                                            showClearButton={true}
                                            disabled={this.state.id > 0}
                                            searchEnabled={true}
                                        />
                                        {this.state.errors["paymentTermId"].length > 0 && <span className="error invalid-feedback">{this.state.errors["paymentTermId"]}</span>}
                                    </div>
                                </div> */}
                                {
                                    this.state.purchaseOrderId > 0 ?
                                        <div className="col-lg-2 col-md-3 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <label htmlFor="">Order Status</label>
                                                <SelectBox
                                                    dataSource={this.state.orderStatusList}
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                    placeholder="Select order status"
                                                    name="id"
                                                    defaultValue={0}
                                                    value={this.state.orderStatusId}
                                                    displayExpr='name'
                                                    valueExpr='id'
                                                    onSelectionChanged={this.handleOrderStatusChange}
                                                    showClearButton={true}
                                                    disabled={false}
                                                    searchEnabled={true}
                                                />
                                                {this.state.errors["accountId"].length > 0 && <span className="error invalid-feedback">{this.state.errors["accountId"]}</span>}
                                            </div>
                                        </div>
                                        : null
                                }
                            </div>
                        </div>
                    </div>
                    <div className='card mb-2'>
                        <div className='card-body'>
                            <div className='sub-title-color font-weight-bold'>Item Info</div>
                            <div className='row'>
                                <div className='col-12'>
                                    <DataGrid
                                        ref="grdPurchaseOrderAttributesRef"
                                        dataSource={this.state.itemDetails}
                                        keyExpr="id"
                                        allowColumnReordering={true}
                                        showBorders={true}
                                        onRowUpdating={this.onRowUpdating}
                                        onRowUpdated={this.onRowUpdated}
                                        onRowInserting={this.onRowInserting}
                                        // onSaving={this.onSaving}
                                        // onSaved={this.onSaved}
                                        onEditorPreparing={this.onEditorPreparing}
                                    >
                                        <Paging enabled={true} />
                                        <Editing mode="row"
                                            allowUpdating={this.state.purchaseOrderId === 0 ? true : false}
                                            allowDeleting={this.state.purchaseOrderId === 0 ? true : false}
                                            allowAdding={this.state.purchaseOrderId === 0 && this.state.accountId > 0 ? true : false}
                                            //allowAdding={true}
                                            editorOptions={true} />
                                        <Column dataField="itemId" caption="Item" setCellValue={this.setCellValue}>
                                            <Lookup dataSource={this.state.itemList} displayExpr="name" valueExpr="id" />
                                            <RequiredRule />
                                        </Column>
                                        <Column dataField="description" caption="Description">
                                            <RequiredRule />
                                            <PatternRule message={'Please enter description'} pattern={alphanumericValidation} />
                                            <StringLengthRule message="Description can not be more than 150 characters" max={150} />
                                        </Column>
                                        <Column dataField="hsnsacCode" caption="HSN Code">
                                            {/* <Lookup dataSource={this.state.hsnsacList} displayExpr="name" valueExpr="code" /> */}
                                            <RequiredRule />
                                        </Column>
                                        <Column dataField="qty" caption="Qty" dataType="numeric" setCellValue={this.calculateQtyChange} alignment="right">
                                            <RequiredRule />
                                            <PatternRule message={'Quantity should be number'} pattern={numberValidation} />
                                        </Column>
                                        <Column dataField="price" caption="Unit Price" dataType="decimal" setCellValue={this.calculatePriceChange} format={"#,##0.##"} alignment="right"
                                            cellRender={renderGridNumberCell}>
                                            <RequiredRule />
                                            <PatternRule message={'Item Price should be decimal'} pattern={floatValidation} />
                                        </Column>
                                        {/* <Column dataField="taxAmount" caption="Tax amount" dataType="decimal" allowEditing={false} format={"#,##0.##"} alignment="right"
                                            cellRender={renderGridNumberCell}>
                                            <RequiredRule />
                                            <PatternRule message={'Tax amount should be decimal'} pattern={floatValidation} />
                                        </Column> */}
                                        {/* <Column dataField="discount" caption="Discount" dataType="decimal" setCellValue={this.calculateDiscountChange} format={"#,##0.##"} alignment="right"
                                            cellRender={renderGridNumberCell}>
                                            <PatternRule message={'Item Discount should be decimal'} pattern={floatValidation} />
                                        </Column> */}
                                        <Column dataField="totalAmount" caption="Total Amount" dataType="decimal" allowEditing={false} format={"#,##0.##"} alignment="right"
                                            cellRender={renderGridNumberCell}>
                                        </Column>
                                        <Summary calculateCustomSummary={this.calculateSelectedRow}>
                                            <TotalItem
                                                name="SelectedRowsSummary"
                                                summaryType="custom"
                                                // valueFormat="currency"
                                                displayFormat="Total - {0}"
                                                showInColumn="discount" />
                                            <TotalItem
                                                name="SelectedTotalSummary"
                                                summaryType="custom"
                                                // valueFormat="currency"
                                                displayFormat="Total - {0}"
                                                showInColumn="totalAmount" />
                                            {/* <Summary>
                                            <TotalItem column="qty" summaryType="sum" customizeText={customizeQtyText} />
                                            <TotalItem column="price" summaryType="sum" customizeText={customizePriceText} />
                                            <TotalItem column="taxAmount" summaryType="sum" customizeText={customizeTaxText} />
                                            <TotalItem column="discount" summaryType="sum" customizeText={customizeDiscountText} />
                                            <TotalItem column="totalAmount" summaryType="sum" customizeText={customizeTotalAmountText} setCellValue ={this.totalGrossAmount} />*/}
                                        </Summary>
                                        <SortByGroupSummaryInfo summaryItem="count" />
                                        {this.state.errors["itemDetailsGrid"].length > 0 && <span className="error invalid-feedback">{this.state.errors["itemDetailsGrid"]}</span>}
                                    </DataGrid>
                                </div>
                            </div>

                            <div className='row mt-2'>
                                <div className='col-9'>
                                    <div className="form-group">
                                        <label htmlFor="">Remarks <span className="text-danger">*</span></label>
                                        {/* <textarea className="form-control" placeholder="Enter remarks here"></textarea> */}
                                        <textarea type="text" className="form-control form-control-sm" name="Remarks" autoComplete="remarks" placeholder="Enter remarks"
                                            maxLength="200" title="Remarks" value={this.state.remarks} onChange={this.handleInputChange} style={{ width: "90%", height: "50px" }} />
                                        {this.state.errors["remarks"].length > 0 && <span className="error invalid-feedback">{this.state.errors["remarks"]}</span>}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="">Terms & Conditions</label>
                                        <textarea type="text" className="form-control form-control-sm" name="TermsAndConditions" autoComplete="termsAndConditions" placeholder="Enter terms & conditions"
                                            maxLength="200" title="Enter terms & conditions" value={this.state.termsAndConditions} onChange={this.handleInputChange} style={{ width: "90%", height: "50px" }} />
                                        {this.state.errors["termsAndConditions"].length > 0 && <span className="error invalid-feedback">{this.state.errors["termsAndConditions"]}</span>}
                                    </div>
                                </div>
                                <div className='col-3'>
                                    <table border="0" cellPadding={"5"} cellSpacing={"0"} width={"100%"} align="right">
                                        <tr>
                                            <td className='text-left'>Shipping Charges</td>
                                            <td>
                                                <NumberBox type="number" className="form-control form-control-sm" name="ShippingCharges" placeholder="Enter shipping charges"
                                                    format="#0.00" defaultValue={0.00} title="Shipping Charges" value={this.state.shippingCharges} onValueChanged={(event) => this.handleShippingChargesChange(event)} min={0.00} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='text-left'>Other Charges</td>
                                            <td>
                                                <NumberBox type="number" className="form-control form-control-sm" name="OtherCharges" placeholder="Enter other charges"
                                                    defaultValue={0.00} title="Other Charges" value={this.state.otherCharges}
                                                    format="#0.00" onValueChanged={this.handleOtherChargesChange} min={0.00} />
                                                {/* {this.state.errors["otherCharges"].length > 0 && <span className="error invalid-feedback">{this.state.errors["otherCharges"]}</span>} */}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='text-left'>Discount</td>
                                            <td>
                                                <NumberBox type="number" className="form-control form-control-sm" name="Discount" placeholder="Enter discount"
                                                    defaultValue={0.00} title="Discount" value={this.state.discount} onValueChanged={this.handleDiscountChange}
                                                    format="#0.00" min={0.00} max={99.99} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='text-left' width="40%">
                                                Tax
                                                <div className='total-tax-amount'>{this.state.accountTaxList == null ? [] : this.state.accountTaxList.map((item, index) => {
                                                    return (
                                                        <span>{item.taxName + '@' + item.percentage + '%'}</span>
                                                    )
                                                })}</div>
                                            </td>
                                            <td>
                                                {/* data.payload[0].taxName */}
                                                {/* {this.state.accountTaxList == null ?[]:    <div>{this.state.accountTaxList[0].taxName + '@' + this.state.accountTaxList[0].percentage}</div> } */}
                                                <NumberBox type="number" className="form-control form-control-sm" name="taxSubTotal" placeholder="0.00"
                                                    defaultValue={0.00} title="taxSubTotal" disabled={true} value={this.state.taxSubTotal} min={0.00} />
                                                {/* {this.state.errors["shippingCharges"].length > 0 && <span className="error invalid-feedback">{this.state.errors["shippingCharges"]}</span>} */}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Gross Amount
                                            </td>
                                            <td>
                                                <NumberBox type="number" className="form-control form-control-sm gross-total" name="GrossAmount" placeholder="0.00" disabled={true}
                                                    format="#0.00" defaultValue={0.00} title="Gross Amount" value={this.state.grossAmount} onValueChanged={this.handleGrossAmountChange} min={0.00} />
                                                {/* {this.state.errors["grossAmount"].length > 0 && <span className="error invalid-feedback">{this.state.errors["grossAmount"]}</span>} */}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='card'>
                        <div className='card-body'>
                            <div className='sub-title-color font-weight-bold'>Document Info</div>
                            <div className='row'>
                                <div className="col-8" style={{ display: this.state.purchaseOrderId === 0 ? 'block' : 'none' }}>
                                    <div className="form-group">
                                        <label htmlFor="">Attach File(s) to New Purchase Order</label>
                                        <input className="form-control" type="file" id="file" onClick={() => { this.removeAll() }} onChange={(e) => { this.handleFileInputChange(e, false) }} />
                                        {/* <label htmlFor="" className='small text-muted'>You can upload a maximum of 5 files, 5MB each</label> */}
                                        {this.state.documentSelectedFile.map((item, index) => {
                                            return (
                                                <div key={index}>
                                                    <label >{item.name} <button value={item.name} onClick={this.resetFileInput} class="btn btn-outline-secondary fas fa-trash text-danger"></button></label>
                                                </div>
                                            );
                                        })}

                                    </div>
                                </div>
                                <div className="col-lg-12 mt-2" style={{ display: this.state.purchaseOrderId > 0 ? 'block' : 'none', color: '#16c0e7' }}>
                                    <span className="sub-title-color font-weight-bold" title="View Document(s)" onClick={() => { this.openDocumentModel() }} ><span className='fas fa-folder'></span>&nbsp;View Document(s)</span>
                                </div>
                                {/* <div className="col-12">
                                    <div className="form-group">
                                        <label htmlFor="">Attach File(s) to Sales Order</label>
                                        <input className="form-control" type="file" id=""/>
                                        <label htmlFor="" className='small text-muted'>You can upload a maximum of 5 files, 5MB each</label>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                <Modal ariaHideApp={false}
                    isOpen={this.state.documentModelIsOpen}
                    style={customStyles}
                    className={"react-modal"}
                    onRequestClose={this.closeDocumentModel}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal">
                    <form method="post" style={this.state.isSubmited ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                        <div className="modal-header">
                            <h6 className="modal-title">Document</h6>
                        </div>
                        <div className="modal-body">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="box-body no-padding" style={{ maxHeight: 400 + 'px', overflowY: "scroll" }}>
                                    <div>
                                        <ul className="users-list clearfix">
                                            {this.state.imageList.length > 0 && this.state.imageList.map((item, j) =>
                                                <li style={{ position: "relative" }} key={j}>
                                                    <a href={item.src} download={item.fileName}><div className="framehover"><img src={item.src} width="150" alt="Image" /></div></a>
                                                </li>
                                            )}
                                            {this.state.pdfList.length > 0 && this.state.pdfList.map((item, j) =>
                                                <li style={{ position: "relative" }} key={j}>
                                                    <a href={item.src} download={item.fileName}><div className="framehover"><img src="../../assets/img/pdf_icon.png" width="150" alt="Blank Image" /></div></a>
                                                </li>
                                            )}
                                            {this.state.excelList.length > 0 && this.state.excelList.map((item, j) =>
                                                <li style={{ position: "relative" }} key={j}>
                                                    <a href={item.src} download={item.fileName}><div className="framehover"><img src="../../assets/img/excel_icon.png" width="100" alt="Blank Image" /></div></a>
                                                </li>
                                            )}
                                            {this.state.otherList.length > 0 && this.state.otherList.map((item, j) =>
                                                <li style={{ position: "relative" }} key={j}>
                                                    <a href={item.src} download={item.fileName}><div className="framehover"><img src="../../assets/img/other_icon.png" width="100" alt="Blank Image" /></div></a>
                                                </li>
                                            )}

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-secondary" onClick={this.closeDocumentModel} title="Cancel">Cancel</button>
                        </div>
                    </form>
                </Modal>
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    position={position}
                    visible={this.state.loadPanelVisible}
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                    hideOnOutsideClick={false}
                />
            </Fragment>
        )
    };
}